<dx-page [options]="pageOptions">

  <ng-container *dxPageHeader>
    <pit-page-header></pit-page-header>
  </ng-container>

  <ng-container *dxPageContent>
    <ng-container *ngIf="!isLoading">
      <dx-navigator [options]="navigatorOptions"
                    [headMenuItems]="topMenuItems"
                    [subMenusMap]="sideMenusMap">
      </dx-navigator>
    </ng-container>
  </ng-container>

<!--
  <ng-container *dxPageFooter>
    <pit-page-footer></pit-page-footer>
  </ng-container>
-->

</dx-page>
